export default {"src":"/_next/static/media/profile.4f90824e.svg","height":400,"width":240,"blurWidth":0,"blurHeight":0};